/**
 * `FormError` — destructive Alert oberhalb eines Formulars.
 *
 * Bewusst kein Toast, weil Form-Errors am Form-Eingangspunkt erwartet
 * werden (statt oben rechts zu erscheinen und beim nächsten Klick zu
 * verschwinden).
 */
import { AlertCircle } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface FormErrorProps {
  /** Wenn falsy, rendert die Komponente nichts. */
  children?: ReactNode;
  className?: string;
}

export function FormError({ children, className }: FormErrorProps) {
  if (!children) return null;
  return (
    <div
      role="alert"
      className={cn(
        "flex items-start gap-2 rounded-md border border-destructive/40 bg-destructive/5 px-3 py-2 text-sm text-destructive",
        className,
      )}
    >
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <p className="leading-snug">{children}</p>
    </div>
  );
}
